import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import helpScoutService from '../../../ml/services/helpScoutService';
import {isObject} from 'lodash';

Vue.use(Vuex);

// Load store modules dynamically.
const requireContext = require.context('./modules', false, /.*\.js$/);

const modules = requireContext.keys()
  .map(file =>
    [file.replace(/(^.\/)|(\.js$)/g, ''), requireContext(file)]
  )
  .reduce((modules, [name, module]) => {
    modules[name] = typeof module.default === 'undefined' ? module : module.default;
    return modules
  }, {});

// https://github.com/robinvdvleuten/vuex-persistedstate
const stateOptions = {
  fetchBeforeUse: true,
  overwrite: true,
  storage: window.localStorage,
};

const dataState = createPersistedState({
  paths: [
    'auth.authenticated',
    'content.sortOption', // MLD-2107
    'search.layout', // MLD-2483
    'system.drawer',
  ]
})

function catchException(err) {

}

const actions = {
  async initStore(context) {
    if (isObject(window.config) && isObject(window.config.user)) {
      console.time('initStore');
      try {
        // MLD-7272 - fetch teams and user in parallel.
        await Promise.all([
          context.dispatch('fetchTeams'),
          context.dispatch('fetchUser')
        ])
        // MLD-7272 then set the current team
        context.commit('setTeam');

        if (context.getters.isAuthenticated) {
          //context.dispatch('fetchTeams').catch(catchException); // MLD-6470
          const user = context.getters.user;
          console.log('User ID', user.id);
          console.log('User Debug Mode', user.is_debug_mode);
          helpScoutService.identify(user); // MLD-3837
          if (context.getters.isAdmin) {
            console.log(`${user.email} is a team administrator`);
            context.dispatch('fetchEmailCreditInfo').then(); // MLD-6180
            context.dispatch('fetchFolders').catch(catchException);
            context.dispatch('fetchFolderTree').catch(catchException);
            context.dispatch('fetchGroups').catch(catchException); // MLD-3003 Performance improvement: only admins need the groups.
            context.dispatch('fetchPresentations').catch(catchException); // MLD-4360
            context.dispatch('fetchProducts').catch(catchException); // MLD-4360
            context.dispatch('fetchShareTemplates').catch(catchException); // MLD-4360
            context.dispatch('fetchShareThemes').catch(catchException); // MLD-4908
            context.dispatch('fetchSpaces').catch(catchException); // MLD-5627
            context.dispatch('fetchUsers').catch(catchException);
          } else {
            console.log(`${user.email} is a team member`);
          }

          context.dispatch('fetchLabels').catch(catchException); // MLD-2483
          context.dispatch('fetchLocales').catch(catchException);
          context.dispatch('content/fetchSpaces').catch(catchException); // MLD-4908
          context.dispatch('content/fetchTemplates').catch(catchException); // MLD-5082
          context.dispatch('refreshTokenPeriodically').catch(catchException); // MLD-4934
          context.dispatch('content/fetchThemes', user.current_team_id).catch(catchException) // MLD-2403
          await context.dispatch('content/initializeCustomerPicker').catch(catchException); // MLD-5823
          await context.dispatch('content/fetchUserData').catch(catchException); // MLD-3342
        }
        return true;
      } catch (e) {
        return false;
      } finally {
        console.timeEnd('initStore');
      }
    }
  }
};

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules,
  actions,
  plugins: [
    dataState,
  ],
})
